import React, {Component} from 'react';
import { Platform, StyleSheet, Text, View, TouchableOpacity} from 'react-native';
import i18n from "../I18n/i18n";
import {moderateScale} from "../tools/Scaling";
import Colors from "../tools/Colors";
import HMTextView from "./HMTextView";
import HMLoading from "./HMLoading";
import RNPickerSelect from "./RNPickerSelect";
import HMIcon from "./HMIcon";
import Dropdown from './dropdown/elementDropdown/components/Dropdown';

let container = null
export default class HMSelectInput extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            isFocus: false,
        }
    }

    render() {
        let {isFocus} = this.state;
        let {DropdownModal, defaultValue, error, requestServer, onValueChange, onPress, styleRoot, style, text, numberOfLines, type, cammas, noFont, options, itemSelectInput, value, index, loading, itemParent, indexParent, title} = this.props;

        const renderLabel = () => {
            // if (value || isFocus) {
            if (true) {
                return (
                    <Text style={[styles.label, isFocus && {color: 'blue'}]}>
                        {title}
                    </Text>
                );
            }
            return null;
        };


        return (
            <View>
                {
                    DropdownModal ?
                        <View
                            // style={styleRoot ? styleRoot : styles.container}
                            style={styles.container}

                        >
                            {renderLabel()}
                            <Dropdown
                                style={[
                                    styles.dropdown,
                                    // style ? style : styles.dropdown,
                                    isFocus && {borderColor: 'blue'}
                                ]}
                                placeholderStyle={styles.placeholderStyle}
                                selectedTextStyle={styles.selectedTextStyle}
                                inputSearchStyle={styles.inputSearchStyle}
                                iconStyle={styles.iconStyle}
                                data={options}
                                search
                                maxHeight={moderateScale(400)}
                                labelField="label"
                                valueField="value"
                                placeholder={!isFocus ? (defaultValue ? defaultValue : i18n.t('constant.SelectItem')) : '...'}
                                // placeholder={!isFocus ? 'Select item' : '...'}
                                searchPlaceholder=" جستجو "
                                value={value ? value : itemSelectInput.label}
                                onFocus={() => this.setState({isFocus: true})}
                                onBlur={() => this.setState({isFocus: false})}
                                onChange={item => {
                                    onValueChange(item.value, item);

                                    this.setState({isFocus: false},
                                        () => {
                                        }
                                    );

                                }}
                                renderLeftIcon={() => (

                                    <HMIcon
                                        type={"AntDesign"}
                                        style={styles.icon}
                                        color={isFocus ? 'blue' : 'black'}
                                        name="Safety"
                                        size={20}
                                    />

                                )}
                            />
                        </View>
                        :

                        <View style={[styleRoot ? styleRoot : {marginHorizontal: moderateScale(12),}]}>
                            {
                                text ?
                                    <HMTextView

                                        //type={"bold"}
                                        //   
                                        style={{
                                            fontSize: moderateScale(12),
                                            marginHorizontal: moderateScale(2),
                                            color: Colors.colorDarkText,

                                            // marginTop: moderateScale(10)
                                        }}
                                        // text={item.status}
                                        text={text}
                                        //   text={"98/03/21"}
                                    />
                                    :
                                    null
                            }

                            <View style={{flexDirection: 'row'}}>
                                {/*<SelectInput style={{*/}
                                {/*borderWidth: moderateScale(1),*/}

                                {/*borderRadius: moderateScale(10),*/}
                                {/*overflow: 'hidden',*/}
                                {/*marginVertical: moderateScale(1),*/}
                                {/*borderColor: Colors.gray,*/}
                                {/*flex:1,*/}


                                {/*}} value={value} options={options}/>*/}
                                <View
                                    style={{
                                        borderWidth: moderateScale(1),

                                        borderRadius: moderateScale(4),
                                        overflow: 'hidden',
                                        marginVertical: Platform.OS === 'ios' ? moderateScale(2) : 0,
                                        borderColor: !value || (value == (defaultValue ? defaultValue : i18n.t('constant.SelectItem'))) ? Colors.gray : Colors.blue,
                                        flex: 1,
                                        padding: Platform.OS === 'ios' ? moderateScale(10) : 0,


                                    }}>
                                    <RNPickerSelect
                                        value={value}
                                        itemKey={index}
                                        itemParent={itemParent}
                                        itemSelectInput={itemSelectInput}
                                        requestServer={requestServer}
                                        onValueChange={onValueChange}
                                        items={options}
                                        placeholder={{
                                            label: (defaultValue ? defaultValue : i18n.t('constant.SelectItem')),
                                            value: null,
                                            //color: Colors.colorDark,
                                        }}
                                        style={{backgroundColor: '#eeb16a'}}
                                        // Icon
                                        selected={!(value == (defaultValue ? defaultValue : i18n.t('constant.SelectItem')))}
                                    />
                                </View>
                                {
                                    loading ?
                                        <HMLoading style={{alignItems: 'center', justifyContent: 'center'}}/>
                                        :
                                        null

                                }
                                {
                                    error ?
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.props.requestServerRetry(null, true)
                                            }
                                            }
                                            style={{alignItems: "center", justifyContent: "center"}}>
                                            <HMTextView

                                                //type={"bold"}
                                                //   
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginHorizontal: moderateScale(2),
                                                    color: Colors.blue,

                                                    // marginTop: moderateScale(10)
                                                }}
                                                // text={item.status}
                                                text={i18n.t('constant.retry')}
                                                //   text={"98/03/21"}
                                            />
                                        </TouchableOpacity>
                                        :
                                        null

                                }
                            </View>
                        </View>
                }

            </View>
        );

    }

}

const styles = StyleSheet.create({
    container: {
        backgroundColor: 'white',
        padding: 16,
    },
    dropdown: {
        height: 50,
        borderColor: 'gray',
        borderWidth: 0.5,
        borderRadius: 8,
        paddingHorizontal: 8,
    },
    icon: {
        marginRight: 5,
    },
    label: {
        position: 'absolute',
        backgroundColor: 'white',
        left: 22,
        top: 8,
        zIndex: 999,
        paddingHorizontal: 8,
        fontSize: 14,
        color: "blue"
    },
    placeholderStyle: {
        fontSize: 16,
    },
    selectedTextStyle: {
        fontSize: 16,
    },
    iconStyle: {
        width: 20,
        height: 20,
    },
    inputSearchStyle: {
        height: 40,
        fontSize: 16,
    },
});
